export const getDriveshaftToleranceClassesByMaxRotorSpeed = (t, maxRotorSpeedLabel = "Ω") => {
  return [
    {
      label: `${maxRotorSpeedLabel} ≤ 500 ${t("units.rotationSpeed.rpm")}`,
      value: 250,
    },
    {
      label: `500 ≤ ${maxRotorSpeedLabel} ≤ 1500 ${t("units.rotationSpeed.rpm")}`,
      value: 150,
    },
    {
      label: `1500 ≤ ${maxRotorSpeedLabel} ≤ 2500 ${t("units.rotationSpeed.rpm")}`,
      value: 100,
    },
    {
      label: `2500 ≤ ${maxRotorSpeedLabel} ≤ 4000 ${t("units.rotationSpeed.rpm")}`,
      value: 60,
    },
    {
      label: `${maxRotorSpeedLabel} ≥ 4000 ${t("units.rotationSpeed.rpm")}`,
      value: 40,
    },
  ];
};
